<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="Proveedores" />

    <div class="flex-grow-1 overflow-auto px-3 pb-3">

      <!-- Buscador -->
      <div class="card mb-3">
        <div class="card-body py-3">
          <div class="row g-2">
            <div class="col-12 col-md-6">
              <input v-model="q" @input="buscarDebounced" type="text"
                class="form-control form-control-sm"
                placeholder="Buscar por razón social o RUC…" />
            </div>
          </div>
        </div>
      </div>

      <!-- Tabla proveedores -->
      <div class="card">
        <div class="card-body p-0">
          <div v-if="cargando" class="text-center py-5 text-muted">
            <div class="spinner-border spinner-border-sm me-2"></div>Cargando…
          </div>
          <div v-else-if="!proveedores.length" class="text-center py-5 text-muted">
            No se encontraron proveedores.
          </div>
          <div v-else class="table-responsive">
            <table class="table table-hover table-sm mb-0">
              <thead class="table-light">
                <tr>
                  <th class="ps-3">Razón Social</th>
                  <th>RUC</th>
                  <th class="text-center">N° Docs</th>
                  <th class="text-end pe-3">Deuda Total (S/)</th>
                  <th class="text-center">Ver</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="p in proveedores" :key="p.idpersona">
                  <td class="ps-3 fw-semibold small">{{ p.razonsocial }}</td>
                  <td class="font-monospace small text-muted">{{ p.nrodoc }}</td>
                  <td class="text-center">
                    <span class="badge bg-secondary-subtle text-secondary">{{ p.num_docs }}</span>
                  </td>
                  <td class="text-end pe-3 fw-bold" :class="parseFloat(p.deuda_total) > 0 ? 'text-danger' : 'text-muted'">
                    {{ formatNum(p.deuda_total) }}
                  </td>
                  <td class="text-center">
                    <button @click="verProveedor(p)" class="btn btn-xs btn-outline-primary" title="Ver documentos">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="totalPags > 1" class="d-flex justify-content-between align-items-center px-3 py-2 border-top">
            <small class="text-muted">{{ total }} proveedores</small>
            <div class="d-flex gap-1">
              <button class="btn btn-sm btn-outline-secondary" :disabled="pagina <= 1" @click="paginar(pagina-1)">‹</button>
              <span class="btn btn-sm btn-secondary disabled">{{ pagina }} / {{ totalPags }}</span>
              <button class="btn btn-sm btn-outline-secondary" :disabled="pagina >= totalPags" @click="paginar(pagina+1)">›</button>
            </div>
          </div>
        </div>
      </div>

    </div><!-- /flex-grow-1 -->

    <MainFooter />
  </div>

  <!-- Modal detalle proveedor -->
  <div v-if="modal" class="modal fade show d-block" style="background:rgba(0,0,0,.45);z-index:1055" @click.self="modal=null">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header py-2">
          <div>
            <h6 class="modal-title fw-bold mb-0">{{ modal.razonsocial }}</h6>
            <small class="text-muted">RUC: {{ modal.nrodoc }}</small>
          </div>
          <button class="btn-close btn-sm" @click="modal=null"></button>
        </div>
        <div class="modal-body py-2">
          <div v-if="cargandoModal" class="text-center py-3">
            <div class="spinner-border spinner-border-sm"></div>
          </div>
          <div v-else>
            <div class="row g-2 mb-3">
              <div class="col-4">
                <div class="rounded-3 bg-danger-subtle p-2 text-center">
                  <div class="small text-muted">Deuda total</div>
                  <div class="fw-bold text-danger">S/ {{ formatNum(deudaTotal) }}</div>
                </div>
              </div>
              <div class="col-4">
                <div class="rounded-3 bg-warning-subtle p-2 text-center">
                  <div class="small text-muted">Docs vencidos</div>
                  <div class="fw-bold text-warning">{{ docsVencidos }}</div>
                </div>
              </div>
              <div class="col-4">
                <div class="rounded-3 bg-secondary-subtle p-2 text-center">
                  <div class="small text-muted">Total docs</div>
                  <div class="fw-bold">{{ modal.documentos?.length || 0 }}</div>
                </div>
              </div>
            </div>
            <div v-if="docsDuplicados > 0" class="alert alert-warning py-2 px-3 mb-2 d-flex align-items-center gap-2">
              <span style="font-size:1.1rem">⚠️</span>
              <span class="small">
                <strong>{{ docsDuplicados }} documento{{ docsDuplicados > 1 ? 's' : '' }} duplicado{{ docsDuplicados > 1 ? 's' : '' }}</strong>
                — el mismo número de factura aparece más de una vez en el sistema del ingeniero.
                Verificar con él para evitar deuda inflada.
              </span>
            </div>
            <div class="table-responsive" style="max-height:360px;overflow-y:auto">
              <table class="table table-sm table-bordered mb-0">
                <thead class="table-light sticky-top">
                  <tr>
                    <th>Documento</th>
                    <th>Fecha</th>
                    <th>Vencimiento</th>
                    <th class="text-end">Importe</th>
                    <th class="text-end">Saldo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="d in modal.documentos" :key="d.idcta"
                    :class="d.es_duplicado ? 'table-warning' : (esVencido(d.fvenc) && parseFloat(d.saldo) > 0 ? 'table-danger' : '')">
                    <td class="font-monospace small">
                      <span v-if="d.es_duplicado" title="Factura duplicada en el sistema del ingeniero" style="cursor:help">⚠️ </span>
                      {{ d.tipo_doc }} {{ d.numdoc }}
                    </td>
                    <td class="small">{{ formatFecha(d.fecha) }}</td>
                    <td class="small" :class="esVencido(d.fvenc) ? 'text-danger fw-semibold' : ''">
                      {{ formatFecha(d.fvenc) }}
                    </td>
                    <td class="text-end small">{{ d.moneda === 'USD' ? '$' : 'S/' }} {{ formatNum(d.importe) }}</td>
                    <td class="text-end fw-bold small" :class="parseFloat(d.saldo) > 0 ? 'text-danger' : 'text-success'">
                      {{ d.moneda === 'USD' ? '$' : 'S/' }} {{ formatNum(d.saldo) }}
                    </td>
                  </tr>
                  <tr v-if="!modal.documentos?.length">
                    <td colspan="5" class="text-center text-muted py-3">Sin documentos registrados</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader    from '../../components/Layouts/MainHeader.vue';
import MainSidebar   from '../../components/Layouts/MainSidebar.vue';
import BreadcrumbMenu from '../../components/Common/BreadcrumbMenu.vue';
import MainFooter    from '../../components/Layouts/MainFooter.vue';
import api from '../../services/api';

export default {
  name: 'ProveedoresPage',
  components: { MainHeader, MainSidebar, BreadcrumbMenu, MainFooter },
  data() {
    return {
      proveedores: [],
      total: 0,
      pagina: 1,
      pageSize: 30,
      cargando: false,
      q: '',
      modal: null,
      cargandoModal: false,
      debounceTimer: null,
    };
  },
  computed: {
    totalPags() { return Math.ceil(this.total / this.pageSize); },
    deudaTotal() {
      return (this.modal?.documentos || [])
        .filter(d => parseFloat(d.saldo) > 0)
        .reduce((s, d) => s + parseFloat(d.saldo), 0);
    },
    docsVencidos() {
      return (this.modal?.documentos || [])
        .filter(d => this.esVencido(d.fvenc) && parseFloat(d.saldo) > 0).length;
    },
    docsDuplicados() {
      const nums = (this.modal?.documentos || []).map(d => d.numdoc);
      return new Set(nums.filter(n => nums.filter(x => x === n).length > 1)).size;
    },
  },
  mounted() { this.cargar(); },
  methods: {
    buscarDebounced() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => { this.pagina = 1; this.cargar(); }, 400);
    },
    async cargar() {
      this.cargando = true;
      try {
        const params = { page: this.pagina, limit: this.pageSize };
        if (this.q) params.q = this.q;
        const r = await api.get('/proveedores', { params });
        const d = r.data?.data ?? r.data;
        this.proveedores = Array.isArray(d) ? d : (d?.data ?? []);
        this.total       = r.data?.pagination?.total ?? this.proveedores.length;
      } catch(e) { console.error(e); this.proveedores = []; }
      finally { this.cargando = false; }
    },
    async verProveedor(p) {
      this.modal = { ...p, documentos: [] };
      this.cargandoModal = true;
      try {
        const r = await api.get(`/proveedores/${p.idpersona}`);
        this.modal = r.data?.data ?? r.data;
      } catch(e) { console.error(e); }
      finally { this.cargandoModal = false; }
    },
    paginar(p) { this.pagina = p; this.cargar(); },
    esVencido(f) { return f && new Date(f) < new Date(); },
    formatFecha(f) {
      if (!f) return '—';
      const s = String(f).substring(0, 10); return new Date(s + 'T00:00:00').toLocaleDateString('es-PE', { day: '2-digit', month: '2-digit', year: 'numeric' });
    },
    formatNum(n) {
      return parseFloat(n || 0).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
  },
};
</script>
